import { Link } from "react-router-dom";
import MainMenu from "./mainmenu";
import Dropdown from 'react-bootstrap/Dropdown';
import { useState, useEffect } from 'react';
import SideBar from './SideBar';
export default function HeaderThree(){
	useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });           
    /* Method that will fix header after a specific scrollable */
	const isSticky = (e) => {
		const header = document.querySelector('.main-header-area');
		const scrollTop = window.scrollY;
		scrollTop >= 250 ? header.classList.add('sticky-menu') : header.classList.remove('sticky-menu');
	};
	const openSideBar = () =>{
		document.body.classList.add('on-side');		
	}
    return(
		<>
			<div className="body-overlay activemode"></div>
			<SideBar/>
			<header className="transparent-header">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 col-sm-6 col-4 pt-10 pb-10">
							<ul className="left-content list-none d-flex align-items-center">
								<li className="d-none d-sm-inline-block">
									<Link className="login-btn" to="/contact"><i className="far fa-address-book "></i>Contact us</Link>
								</li>
								<li>
									<div className="right-language">
										
										<Dropdown>
											<Dropdown.Toggle variant="" id="dropdownMenuLink" className="language-btn dropdown-toggle">
												Language <i className="fal fa-chevron-down"></i>
											</Dropdown.Toggle>

											<Dropdown.Menu className="dropdown-menu" aria-labelledby="dropdownMenuLink">
												<Dropdown.Item href="#/action-1" className="dropdown-item">English</Dropdown.Item>
												<Dropdown.Item href="#/action-2" className="dropdown-item">Arbic</Dropdown.Item>
												<Dropdown.Item href="#/action-3" className="dropdown-item">Spanish</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</div>
								</li>
							</ul>
						</div>
						<div className="col-lg-6 col-sm-6 col-8 text-end pt-10 pb-10">
							<div className="footer__social-two">
								<a href="#"><i className="fab fa-facebook-f"></i></a>
								<a href="#"><i className="fab fa-twitter"></i></a>
								<a href="#"><i className="fab fa-behance"></i></a>
								<a href="#"><i className="fab fa-linkedin-in"></i></a>
								<a href="#"><i className="fab fa-youtube"></i></a>
							</div>
						</div>
					</div>
				</div>
				<div className="main-header-area">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-2 col-6">
								<div className="logo-area">
									<Link className="front" to="/"><img src="assets/img/logo/header-logo-3.png" alt="Header-logo" /></Link>
									<Link className="back" to="/"><img src="assets/img/logo/header-logo-1.png" alt="Header-logo" /></Link>
								</div>
							</div>
							<div className="col-lg-10 col-6 text-end text-lg-start">
								<div className="menu-style-3">
									<MainMenu/>
									<div className="right-content">
										<div className="hamburger-menu d-md-inline-block d-lg-none">
											
											<a  onClick={openSideBar}><img src="assets/img/icon/eclips-1.png" alt="Eclips" /></a>
										</div>
										<div className="d-none d-md-inline-block">
											<Link className="quote-border-btn" to="/contact">Free Consultancy</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			
			</header>
		</>
        
    )
}